import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function Download() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);

  function getOrCreateSeed() {
    let seed = localStorage.getItem("seed");
    if (!seed) {
      seed = Math.random().toString(36).substring(2);
      localStorage.setItem("seed", seed);
    }
    return seed;
  }


  async function generateFingerprint() {
    try {
      const data = [
        navigator.userAgent || "",
        navigator.language || "",
        window.screen?.width || "",
        window.screen?.height || "",
        window.screen?.colorDepth || "",
        Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        getOrCreateSeed(),
      ].join("|");

      if (!window.crypto?.subtle) {
        return simpleHash(data);
      }

      const hashBuffer = await crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(data)
      );

      return [...new Uint8Array(hashBuffer)]
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
    } catch (err) {
      console.error("Fingerprint generation failed:", err);
      return simpleHash(Date.now().toString()); // emergency fallback
    }
  }

  function simpleHash(str) {
    let hash = 0, i, chr;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0;
    }
    return Math.abs(hash).toString(16);
  }

  useEffect(() => {
    const incrementCount = async () => {
      const src = searchParams.get("src") || "direct";

      try {
        const fingerprint = await generateFingerprint();
        await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/link-count/${src}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ fingerprint })
          }
        );
      } catch (err) {
        console.error("Count increment failed:", err);
      }
    };

    const redirectUser = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      const iosUrl = 'https://apps.apple.com/us/app/hynt-homes-made-easy/id6752606030';
      const androidUrl = 'https://play.google.com/store/apps/details?id=com.hynt.app';
      const fallbackUrl = 'https://hynt.co.in/';

      const isIOS = () => {
        return (
          [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
          ].includes(navigator.platform)
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
        );
      };
      if (/android/i.test(userAgent)) {
        window.location.href = androidUrl;
      } else if (isIOS()) {        
        window.location.href = iosUrl;
      } else {
        window.location.href = fallbackUrl;
      }
    };

    const startProcess = async () => {
      await incrementCount();              
      setTimeout(() => redirectUser(), 800);
    };

    startProcess();
  }, []);


  if (!isLoading) return null;

  return (
    <div style={styles.container}>
      <div style={styles.loader}></div>
      <p style={styles.text}>Just a moment…</p>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff"
  },
  loader: {
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    animation: "spin 1s linear infinite"
  },
  text: {
    marginTop: "16px",
    fontSize: "16px",
    color: "#333"
  }
};

// Add global spinner animation
const style = document.createElement("style");
style.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(style);

export default Download;
